import RelatedLinks from './RelatedLinks.vue'

export default RelatedLinks
